/** Path suffix of the provider redirect. Region prefix is stripped before matching. */
const OAUTH_CALLBACK_PATH = '/recall-calendar/oauth/callback'

/** The callback query captured before the address bar is stripped, consumed once by the route. */
let capturedSearch: string | null = null

/** True when this pathname is the calendar OAuth landing route. */
export function isCalendarOAuthCallbackPath(pathname: string): boolean {
   return pathname.includes(OAUTH_CALLBACK_PATH)
}

/**
 * Stashes the provider callback query and strips it from the address bar. Must run before Sentry
 * initialises — session replay records `location.href` at init, independently of `beforeSend`.
 */
export function captureAndStripOAuthCallbackSearch(): void {
   if (typeof window === 'undefined') return
   if (!isCalendarOAuthCallbackPath(window.location.pathname)) return

   const search = window.location.search
   if (!search || search === '?') return

   capturedSearch = search
   window.history.replaceState(null, '', window.location.pathname + window.location.hash)
}

/**
 * The callback query, preferring the stash written before Sentry started. Consuming clears it so a
 * later visit cannot replay a captured code.
 */
export function takeOAuthCallbackSearch(): URLSearchParams {
   if (capturedSearch !== null) {
      const search = capturedSearch
      capturedSearch = null
      return new URLSearchParams(search.startsWith('?') ? search.slice(1) : search)
   }
   return new URLSearchParams(typeof window === 'undefined' ? '' : window.location.search)
}
